import { parse } from 'date-fns/parse';
import { format } from 'date-fns/format';

/**
 * Ensures an input date of type string or date is returned as a Date object.
 * @param date
 * @returns
 */
export function ensureIsDate(date: string | Date): Date {
  if (typeof date === 'string') {
    return new Date(date);
  }
  return date;
}

/**
 * Parses a date using date-fns parse function. The date is expected to be in the format of the dateFormat parameter.
 * This function ensures the date is in UTC when parsed. Meaning that the date is not converted to the local timezone.
 * Useful for parsing dates that should not be affected by the local timezone, such as birthdates.
 *
 * Parsing the date string '05-01-2024' with the standard parse function from date-fns without specifying the timezone
 * would result in the following date, assuming the local time is UTC+2: 2024-04-30T22:00:00.000Z where we would expect 2024-05-01T00:00:00.000Z for UTC.
 */
export function parseDateInUTC(dateString: string, dateFormat: string): Date {
  return parse(`${dateString}Z`, `${dateFormat}X`, new Date());
}

/**
 * Formats a date using date-fns format function but forces the output to be in UTC.
 * Useful for formatting dates that should not be affected by the local timezone, such as birthdates.
 */
export function formatDateInUTC(date: Date, dateFormat: string): string {
  return format(
    // Create a new date object with the same date as the input date but force UTC time.
    // Keep in mind that this is techically not the same point in time as the input date but just local time with the UTC values.
    // but it will be formatted as the same date, as long as no timezone is displayed.
    new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
    ),
    dateFormat,
  );
}
